import { Skeleton } from '@mui/material'

import { Row, RowProps } from '..'

interface Props extends RowProps {
  isLoading?: boolean
  label?: React.ReactNode
  value?: React.ReactNode
}
export const LabelValueRow = ({ isLoading = false, label, value, ...props }: Props) => {
  if (isLoading) {
    return (
      <Row {...props}>
        {label || <Skeleton height="16px" width="100px" />}
        <Skeleton height="16px" width="100px" />
      </Row>
    )
  }

  return (
    <Row {...props}>
      <span>{label}</span>
      <span>{value ?? '–'}</span>
    </Row>
  )
}
